import { render, staticRenderFns } from "./ConsultarExpressao.vue?vue&type=template&id=2006eac1&scoped=true&"
import script from "./ConsultarExpressao.vue?vue&type=script&lang=js&"
export * from "./ConsultarExpressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006eac1",
  null
  
)

export default component.exports